import React from "react";
import {Button, Card} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {useSelector} from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Link} from "react-router-dom";
import {AddRemoveIconButtons} from "@cabinet-packages/components";

const useStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
    },
    media: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        padding: '16px',
        rowGap: '7px',
    },
    name: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: '22px',
        lineHeight: 1.3,
        marginBottom: '16px',
    },
    priceRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 'auto',
    },
    prices: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        columnGap: '10px',
    },
    oldPrice: {
        color: theme.palette.grey.A200,
        textDecoration: 'line-through',
        fontSize: '18px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
    },
    newPrice: {
        color: theme.palette.primary.main,
        fontSize: '24px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
    },
    addButton: {
        color: theme.palette.primary.main,
    },
    detailsButton: {
        width: '100%',
        borderRadius: '999px',
        padding: '6px 10px',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: theme.palette.primary.main,
        color: '#ffffff',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
}));

const formatPrice = (value) => {
    const rounded = Math.round(value * 100) / 100;
    return Number.isInteger(rounded) ? rounded : rounded.toFixed(2);
};

const MediaCard = ({item, isComponentInShop}) => {
    const classes = useStyles();
    const {orderingList} = useSelector(state => state.orderAssays);
    const {actions} = useSelector(state => state.assaysCatalog);
    const {imgUrl} = useSelector(store => store.theme);

    const hasDiscount = !!item.discount && item.discount > 0;
    const discountedPrice = hasDiscount
        ? item.price - item.price * item.discount / 100
        : item.price;

    const detailsPath = isComponentInShop
        ? `/shop-actions-details/${item.id}`
        : `/actions-details/${item.id}`;

    const isIncludedInOrderingList = orderingList.find(assay => assay.id === item.id && assay.type === item.type);
    const actionInOrderList = orderingList.filter(actionID => actions.find(action => action.id === actionID.id && actionID.type === item.type));

    return (
        <Card className={classes.card} raised={true}>
            <img
                className={classes.media}
                src={
                    !!item.fileName
                        ? `https://biokurs-billing.medclinic.in.ua/modules/bi_action/files/${item.fileName}`
                        : imgUrl
                }
                alt={item.name}
            />
            <div className={classes.content}>
                <Typography className={classes.name}>
                    {item.name}
                </Typography>
                <div className={classes.priceRow}>
                    <div className={classes.prices}>
                        {hasDiscount && (
                            <span className={classes.oldPrice}>{formatPrice(item.price)}&nbsp;грн</span>
                        )}
                        <span className={classes.newPrice}>{formatPrice(discountedPrice)}&nbsp;грн</span>
                    </div>
                    <div className={classes.addButton}>
                        <AddRemoveIconButtons
                            item={item}
                            isIncludedInOrderingList={isIncludedInOrderingList}
                            actionInOrderList={actionInOrderList}
                        />
                    </div>
                </div>
                <Button
                    className={classes.detailsButton}
                    component={Link}
                    to={detailsPath}
                >
                    Детальніше
                </Button>
            </div>
        </Card>
    );
};

export default MediaCard;
